import { z } from "zod";

export const createWhatsappMetaFormSchema = (requiredMessage: string) =>
  z.object({
    label: z.string().optional(),
    waba_id: z.string().min(1, { message: requiredMessage }),
    access_token: z.string().min(1, { message: requiredMessage }),
  });

export const editWhatsappMetaFormSchema = (requiredMessage: string) =>
  z.object({
    label: z.string().optional(),
    waba_id: z.string().min(1, { message: requiredMessage }),
    access_token: z.string().optional(),
  });

export type TWhatsappMetaFormData = z.infer<
  ReturnType<typeof createWhatsappMetaFormSchema>
>;

export type TWhatsappMetaEditFormData = z.infer<
  ReturnType<typeof editWhatsappMetaFormSchema>
>;
